export default __webpack_public_path__ + "static/top-6019eb753e0b7f32a175202316e2f9cd.jpg";